window.addEventListener('DOMContentLoaded', function() {
    var e = $(".content-wrapper"),
        r = 100;
        
    $('.tabs-wrapper .tabs-wrapper').css('min-height', r);

    $(".hero-info__btn img").on('click', function () {
        $(".hero-image").css({
            transform: "translateX(100%)"
        }), $(".hero").css({
            transform: "translateX(100%)"
        }), $(".video").css({
            transform: "none",
            opacity: 1,
            visibility: "visible"
        })
    });

    $(".tabs-wrapper .tabs .tab-link").on('click', function() {
        if($(this).data('target')) {
            $(".tabs-wrapper .tabs .tab-link").removeClass("active");
            $(this).addClass("active");

            var target = $(this).data('target');
            var tab_height = r;

            if (!$(".tabs-wrapper .tabs").hasClass("tabs-sticky")) {
                tab_height = $('.tabs-wrapper').height();
            } 

            $(".tab-section").hide();
            $("#"+ target).fadeIn();
            $("html, body").animate({
                scrollTop: ($("#"+ target).offset().top - (tab_height + 50) - $('.header-wrapper').height())
            }, 1e3);
        }
    });

    function o() {
        $(".pos").offset().top - 0 <= $(this).scrollTop() ? 
        (
            $(".tabs-wrapper .tabs").addClass("tabs-sticky")
        ) 
        : 
        (
            $(".tabs-wrapper .tabs").removeClass("tabs-sticky")
        )
    }

    o();

    function a() {
        $(window).width() <= 768 && (e.css({
            paddingTop: 0
        }), $(".tabs-wrapper .tabs").removeClass("tabs-sticky"))
    }

    a();
    
    $(window).on("scroll", function () {
        o(), a()
    });
            
    $(window).resize(function () {
        o(), a()
    }); 

    $(".section-in__link a").click(function () {
        return $("html, body").animate({
            scrollTop: $($.attr(this, "href")).offset().top
        }, 1e3), !1
    });
    
    var swiperEvents = new Swiper('.swiper-events .swiper-container', {
        loop: true,
        width: 410,
        spaceBetween: 40,
        calculateHeight: true,
        loopedSlides: 12,
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        },
        breakpoints: {
        580: {
            width: 280,
            spaceBetween: 10
        }
        }
    });
    

    $(".apply-btn[data-fancybox]").on("click", function(e) {
        e.preventDefault();

        var src = '';
        if ($(this).hasClass('apply-btn--project')) {
            src = '#hubspot-contact-form--project';
        } else {
            src = '#hubspot-contact-form--event';
        }

        $.fancybox.open({
            src  : src,
            type : 'inline',
            width : '100%',
            height : 'auto'
        });
    });

});  